<div class="flex">
  <sbnb-subnav [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav />
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-content-header
      title="Your Brand"
      novaContentId="settings-brands-edit"
      [saving]="saving()"
      [recentlySaved]="recentlySaved()"
      (saveClicked)="save()"></sbnb-content-header>

    @if (loading()) {
      <sbnb-loading-spinner />
    }

    @if (brand()) {
      <div class="flex flex-col sbnbDesktop:flex-row gap-4 w-full mt-4">
        <div class="w-full sbnbDesktop:w-1/2">
          <sbnb-upload-assets
            label="Brand logo"
            assetType="logo"
            [thumbnails]="[brand().logo_url]"
            [options]="{
              maxFiles: 1,
              fromSources: ['local_file_system', 'url'],
              accept: ['image/jpeg', 'image/png']
            }"
            (uploadSuccess)="logoUploadSuccess($event)"
            (remove)="logoRemove()"></sbnb-upload-assets>
        </div>

        <div class="w-full sbnbDesktop:w-1/2">
          <sbnb-upload-assets
            label="Brand icon"
            assetType="icon"
            [thumbnails]="[brand().icon_url]"
            [options]="{
              maxFiles: 1,
              fromSources: ['local_file_system', 'url'],
              accept: ['image/jpeg', 'image/png']
            }"
            (uploadSuccess)="iconUploadSuccess($event)"
            (remove)="iconRemove()"></sbnb-upload-assets>
        </div>
      </div>

      <div class="w-full mt-12">
        <label class="block text-sm text-gray-600" for="name">Brand name</label>

        <mat-form-field class="w-full">
          <input matInput name="name" placeholder="Brand name" [(ngModel)]="brand().name" required />
          <mat-error>Brand name is required</mat-error>
        </mat-form-field>
      </div>

      <!-- socials -->
      <div class="w-full mt-4">
        <h3 class="mb-3">Socials</h3>

        @for (social of brand().socials; track social.type) {
          <div class="w-full">
            <div class="flex flex-col sm:flex-row gap-4 items-center mb-4">
              <div class="flex gap-2 w-full sm:w-[30%] sm:gap-0">
                <mat-form-field class="w-full nopadding">
                  <mat-select [(ngModel)]="social.type" placeholder="Platform">
                    <mat-select-trigger>
                      <div class="flex gap-2 items-center">
                        <sbnb-icon [size]="18" [icon]="getSocialTypeMetadata(social.type).icon" />
                        <span>{{ getSocialTypeMetadata(social.type).label }}</span>
                      </div>
                    </mat-select-trigger>

                    @for (type of getAvailableSocialTypesForSocial(social.type); track type) {
                      <mat-option [value]="type">
                        @if (getSocialTypeMetadata(type)?.label) {
                          <div class="flex gap-2 items-center">
                            <sbnb-icon [size]="18" [icon]="getSocialTypeMetadata(type).icon" />
                            <span>{{ getSocialTypeMetadata(type).label }}</span>
                          </div>
                        } @else {
                          {{ type }}
                        }
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <sbnb-icon
                  icon="trash"
                  [matTooltip]="'Remove ' + getSocialTypeMetadata(social.type).label"
                  class="text-raspberry-darker cursor-pointer self-center sm:hidden"
                  (click)="deleteSocial(social.type)"></sbnb-icon>
              </div>

              <mat-form-field class="w-full nopadding">
                <input
                  matInput
                  [(ngModel)]="social.handle"
                  [placeholder]="'Enter ' + getSocialTypeMetadata(social.type).label + ' handle'" />
              </mat-form-field>

              <sbnb-icon
                icon="trash"
                [matTooltip]="'Remove ' + getSocialTypeMetadata(social.type).label"
                class="text-raspberry-darker cursor-pointer hidden sm:block"
                (click)="deleteSocial(social.type)"></sbnb-icon>
            </div>
          </div>
        }

        @if (getNextAvailableSocialType().length > 0) {
          <div class="mt-4">
            <sbnb-button type="secondary" size="mini" (click)="addSocial()">+ Add social</sbnb-button>
          </div>
        }
      </div>
    }
  </main>
</div>

<!-- todoben -->
<!-- <sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar> -->
